import $ from "@modules/jquery";

export default function() {
    var $headerSpkAuto = $(".secondaryMenu-spk-auto");
    if($headerSpkAuto.length > 0) {
        $(window).on('scroll', function () {
            var scroll = $(window).scrollTop();
            if (scroll > 100) {
                $headerSpkAuto.addClass("scrolled");
            } else {
                $headerSpkAuto.removeClass("scrolled");;
            }
        });      
    }
}